import React, { memo } from 'react';
import { Edit2 } from 'lucide-react';
import { MechanicalContractor } from './types';

interface MechanicalContractorDetailsHeaderProps {
  contractor: MechanicalContractor;
  onEdit: () => void;
  canEdit: boolean;
}

const MechanicalContractorDetailsHeader = memo(({
  contractor,
  onEdit,
  canEdit
}: MechanicalContractorDetailsHeaderProps) => {
  return (
    <div className="flex items-center justify-between p-6 border-b border-gray-200">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mt-1">{contractor.name}</h1>
      </div>
      {canEdit && (
        <button
          onClick={onEdit}
          className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          <Edit2 className="w-4 h-4 mr-2" />
          Edit Contractor
        </button>
      )}
    </div>
  );
});

MechanicalContractorDetailsHeader.displayName = 'MechanicalContractorDetailsHeader';

export default MechanicalContractorDetailsHeader;